'use client'

import { format } from 'date-fns'
import { CalendarIcon } from 'lucide-react'

import { Button, PopoverTrigger } from '../index'
import { cn } from '../lib/utils'
import { Calendar } from './calendar'
import { Popover, PopoverContent } from './popover'

type DatePickerProps = {
  className?: string
  date?: Date
  disabled?: boolean
  onSelect: (date: Date | undefined) => void
  placeholder?: string
  align?: 'start' | 'center' | 'end'
}

/**
 * This component is a date picker that allows the user to select a date.
 * It is a wrapper around the Popover component.
 */
export function DatePicker({
  date,
  onSelect,
  disabled,
  placeholder = 'Pick a date',
  align = 'center',
  className
}: DatePickerProps) {
  return (
    <Popover modal>
      <PopoverTrigger asChild>
        <Button
          variant={'outline'}
          className={cn(
            'w-[200px] justify-start text-left font-normal',
            !date && 'text-muted-foreground',
            disabled && 'cursor-not-allowed',
            className
          )}
          disabled={disabled}
        >
          <CalendarIcon />
          {date ? format(date, 'PPP') : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align={align}>
        <Calendar
          mode="single"
          selected={date}
          onSelect={onSelect}
          initialFocus
          disabled={disabled}
          defaultMonth={date}
        />
      </PopoverContent>
    </Popover>
  )
}
